import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getForms = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `forms${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch forms");
    return error;
  }
};

export const updateFormStatus = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `forms/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Form updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update form status");
    return error;
  }
};

export const addTestimonials = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `forms/feedback`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Feedback added successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to add feedback");
    return error;
  }
};